var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3523 2.60225C12.5719 2.38258 12.9281 2.38258 13.1478 2.60225L15.3978 4.85225C15.6174 5.07192 15.6174 5.42808 15.3978 5.64775L13.1478 7.89775C12.9281 8.11742 12.5719 8.11742 12.3523 7.89775C12.1326 7.67808 12.1326 7.32192 12.3523 7.10225L13.642 5.8125H6.75001C6.03869 5.8125 5.54281 5.81304 5.15835 5.84788C4.78161 5.88203 4.56743 5.94553 4.40625 6.03858C4.14972 6.18669 3.9367 6.39972 3.78859 6.65624C3.69553 6.81742 3.63203 7.03161 3.59789 7.40834C3.56304 7.79281 3.5625 8.28868 3.5625 9C3.5625 9.71131 3.56304 10.2072 3.59788 10.5917C3.63203 10.9684 3.69553 11.1826 3.78858 11.3438C3.93669 11.6003 4.14972 11.8133 4.40625 11.9614C4.56743 12.0545 4.78161 12.118 5.15835 12.1521C5.54281 12.187 6.03869 12.1875 6.75 12.1875H12C12.3107 12.1875 12.5625 12.4393 12.5625 12.75C12.5625 13.0607 12.3107 13.3125 12 13.3125H6.72317C6.04498 13.3125 5.49802 13.3125 5.0568 13.2725C4.60204 13.2313 4.20469 13.1441 3.84375 12.9357C3.4162 12.6888 3.06115 12.3338 2.8143 11.9062C2.60592 11.5453 2.51869 11.148 2.47748 10.6932C2.43749 10.252 2.43749 9.70502 2.4375 9.02684V8.97316C2.43749 8.29498 2.43749 7.74802 2.47748 7.30679C2.5187 6.85203 2.60592 6.45468 2.81431 6.09374C3.06116 5.66619 3.4162 5.31115 3.84375 5.06431C4.20469 4.85592 4.60204 4.76869 5.0568 4.72748C5.49802 4.68749 6.04498 4.68749 6.72316 4.6875L13.642 4.6875L12.3523 3.39775C12.1326 3.17808 12.1326 2.82192 12.3523 2.60225Z",
    fill: "#F7F6FD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/Deposit.fc96e18a92225e57e77b18edf4f344f8.svg";
export { ForwardRef as ReactComponent };